import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CsvService {

    export(data: null | any[]): void {

        const rows = Array.isArray(data) ? data : [];

        const csv = this.buildCsv(rows);
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });

        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `data-${Date.now()}.csv`;
        a.click();
        URL.revokeObjectURL(a.href);
    }

    // ---- helpers ----

    private buildCsv(rows: any[]): string {

        if (!rows.length) {
        // empty file with BOM so Excel opens it as UTF-8
        return '\uFEFF';
        }

        // Derive stable column list: first row keys in order, then add any new keys as they appear.
        let cols: string[] = [];
        for (const r of rows) {
        if (r && typeof r === 'object' && !Array.isArray(r)) {
            if (cols.length === 0) {
            cols = Object.keys(r);
            } else {
            for (const k of Object.keys(r)) {
                if (!cols.includes(k)) cols.push(k);
            }
            }
        }
        }
        if (cols.length === 0) {
        // Fallback: treat primitives/arrays as single-column strings
        const lines = rows.map(v => this.escape(String(v)));
        return '\uFEFF' + lines.join('\r\n');
        }

        const header = cols.join(',');
        const lines = rows.map(r => cols.map(c => this.escape(this.cell(r?.[c]))).join(','));

        // Prepend BOM for Excel + CRLF line endings
        return '\uFEFF' + [header, ...lines].join('\r\n');
    }

    private cell(v: any): string {

        if (v == null) return '';
        if (v instanceof Date) return v.toISOString();
        return String(v);
    }

    private escape(s: string): string {
        
        // Quote if contains comma, quote, or newline. Double quotes inside.
        const needs = /[",\r\n]/.test(s);
        if (!needs) return s;
        return `"${s.replace(/"/g, '""')}"`;
    }
}
